import { examAdminPapersDetail } from "./exam-admin-papers-detail";
import { examAdminPaperEditor } from "./exam-admin-paper-editor";

export const examAdminPapers = {
  pageTitle: "试卷中心",
  pageSubtitle: "通过可视化规则和题目清单维护试卷，系统自动生成试卷编号和结构化数据。",
  createPaper: "新建试卷",
  createSuccess: "试卷创建成功",
  archiveSuccess: "试卷已归档",
  deleteSuccess: "试卷已删除",
  paperTotal: "试卷总数",
  availableQuestions: "可选题目",
  latestPaper: "最近试卷",
  viewDetail: "查看",
  paperDescription: "试卷说明",
  noDescription: "暂无说明",
  questionCatalogNotReady: "The question catalog is not ready yet. Try again later.",
  questionList: "题目清单",
  searchPlaceholder: "按试卷编号或名称搜索",
  questionTypeDistribution: "题型分布",
  showArchived: "Show archived",
  hideArchived: "Hide archived",
  summaryArchivedVisible: "Archived visible: {value}",
  summaryTotal: "Total papers: {count}",
  summaryLatestPaper: "Latest paper: {title}",
  stats: {
    summaryUnavailable: "Paper status counts failed to load; legend counts are unavailable",
  },
  messages: {
    selectDraftsToPublish: "Only draft papers can be published. Please reselect.",
    selectArchivableToArchive: "No archivable papers are currently selected",
    selectDraftsToDelete: "Only draft papers can be deleted. Please reselect.",
    batchPublished: "Published {count} papers",
    batchArchived: "Archived {count} papers",
    batchDeleted: "Deleted {count} draft papers",
  },
  batchSelection: {
    partialSelected:
      "Selected first {selected} items ({total} items match the current filters; the remainder is not selected)",
    allSelected: "Selected {count} items",
  },
  confirmBatch: {
    publishDraftsTitle: "Publish the selected {count} draft papers?",
    archiveTitle: "Archive the selected {count} papers?",
    deleteDraftsTitle: "Delete the selected {count} draft papers?",
    deleteDraftsDescription: "This action cannot be undone.",
  },
  newPaperDrawerTitle: "新建试卷",
  previousStep: "上一步",
  nextStep: "下一步",
  basicInfoStepTitle: "基础信息",
  basicInfoStepDescription: "状态、名称、卷型",
  composeStepTitle: "组卷配置",
  composeStepDescription: "规则与选题、分值",
  confirmStepTitle: "确认提交",
  confirmStepDescription: "预览结构化数据",
  codeRulePrefix: "试卷编号由系统在首次保存成功后自动生成，格式为",
  codeRulePattern: "P-卷型字母-年周-序号",
  codeRuleSuffix: "，生成后不可修改。",
  createPageTitle: "新建试卷 · {paperType}",
  createPageSubtitle: "独立创建页：减少卷型切换导致的状态干扰",
  titleRequired: "请输入试卷名称",
  titlePlaceholder: "输入试卷名称",
  titleOptionalPlaceholder: "可先留空，在确认提交时补充",
  titleFillAtConfirmHint: "试卷名称将在确认提交时填写，支持 AI 推荐。",
  autoDraftTitle: "未命名草稿试卷",
  draftCreated: "草稿已创建，继续组卷即可",
  descriptionPlaceholder: "说明试卷目标、适用范围、发布说明等",
  confirmHint: "请确认试卷配置后提交",
  durationPlaceholder: "可留空，默认不展示时长提示",
  aiSuggestedTitle: "AI 推荐名称",
  previewUnavailable: "当前配置无法生成预览，请返回上一步检查。",
  previewAppliedHint: "规则与题目清单已按当前配置生效，确认后将直接保存。",
  previewTypeDistributionLabel: "题型分布",
  previewTypeDistributionSummary: "题型分布：{summary}",
  previewTypeDistributionItem: "{type}{count}题",
  previewTypeDistributionEmpty: "未生成（请先完成组卷）",
  questionCountSummary: "{count} 题",
  totalScoreSummary: "{score} 分",
  previewEmptyTitle: "当前未选题",
  previewEmptyDescription: "请返回第二步完成组卷后再保存。",
  completeRequiredFields: "请先完善必填信息后再保存",
  addAtLeastOneQuestion: "请至少加入一道题目",
  itemSummary: "题目版本 #{questionVersionId} · 顺序 {sortOrder} · 分值 {score}",
  pickerDraftNotFound: "未找到选题草稿，无法回填题目清单",
  popupBlocked: "浏览器拦截了新标签页，请允许弹窗后重试。",
  recommendedTitleCreated: "已生成推荐试卷名称",
  recommendedTitleTemplate: "{type}能力测评卷（{count}题）{date}",
  manualComposeInfo: "手工组卷建议在独立选题工作台完成，完成后回到当前页面确认。",
  manualComposeSelectedCount: "当前已选题目：{count} 题",
  manualComposeDescription:
    "点击“进入选题工作台”后，会在独立页面完成筛选、批量加入、排序和分值配置。",
  openManualWorkspace: "进入选题工作台",
  finishManualSelection: "选题完成，去确认",
  pickerSyncedHint: "已同步 {count} 道题，是否进入确认步骤？",
  pickerSyncModalTitle: "选题已同步",
  pickerSyncModalSubmit: "进入确认",
  pickerSyncModalReset: "继续调整",
  pickerSyncModalContent: "已完成选题同步，是否进入确认步骤？",
  pickerSyncModalDiffTitle: "覆盖前差异摘要",
  pickerSyncModalDiffAdded: "新增题目：{count}",
  pickerSyncModalDiffRemoved: "移除题目：{count}",
  pickerSyncModalDiffScoreChanged: "分值变化：{count}",
  pickerSyncModalDiffOrderChanged: "顺序变化：{count}",
  pickerSyncModalDiffHint: "点击“进入确认”后将按选题工作台结果覆盖当前组卷内容。",
  differentiatedInfo: "按题型设定数量、每题分值和筛选规则，系统会实时校验题库是否足够。",
  differentiatedAddRule: "新增题型规则",
  differentiatedDeleteRule: "删除规则",
  differentiatedRuleTitle: "题型规则 {index}",
  differentiatedValidationLabel: "规则校验：",
  differentiatedValidationSummary: "需求 {requiredCount} 题 / 可选 {availableCount} 题",
  differentiatedEnough: "充足",
  differentiatedInsufficient: "不足",
  differentiatedKnowledgePointsScope: "知识点范围",
  differentiatedKnowledgePointsPlaceholder: "输入后回车，可配置多个知识点",
  differentiatedTagsScope: "标签范围",
  differentiatedTagsPlaceholder: "输入后回车，可配置多个标签",
  differentiatedSummary: "当前合计：{questionCount} 题，{totalScore} 分",
  differentiatedQuestionTypeRequired: "请选择题型",
  differentiatedCountRequired: "请输入数量",
  differentiatedScoreRequired: "请输入分值",
  differentiatedQuestionBankLoading: "题库正在加载，请稍后再试",
  differentiatedAddAtLeastOneRule: "请至少添加一个题型规则",
  differentiatedCompleteRuleFields: "请完成每个题型的题型、数量和每题分值",
  differentiatedInsufficientQuestions: "当前规则下题目数量不足，请调整后再继续",
  differentiatedInsufficientQuestionsBeforeSubmit: "当前规则下题目数量不足，请先修正规则",
  batch: {
    publishDrafts: "Batch publish (drafts only)",
    archive: "Batch archive",
    deleteDrafts: "Batch delete (drafts only)",
    confirmDeleteDraftsDescription: "This action cannot be undone.",
    archiveAction: "Archive",
    confirmPublishDraftsTitle: "Publish the selected draft papers in batch?",
    confirmArchiveTitle: "Archive the selected papers in batch?",
    confirmDeleteDraftsTitle: "Delete the selected draft papers in batch?",
    publishAction: "Batch publish",
  },
  editor: examAdminPaperEditor,
  notFoundPage: {
    subtitle: "页面不存在",
    backToDashboard: "返回平台总览",
  },
  accessDenied: {
    subtitle: "当前账号无权访问这个页面",
    backToDashboard: "返回平台总览",
  },
  runtimeError: {
    title: "管理端发生了未预期错误",
    subtitle: "请刷新页面，或先返回平台总览后重试。",
  },
  rolePermissions: {
    catalogTitle: "角色目录",
    matrixTitle: "权限矩阵",
    permissionColumn: "权限点",
    allowed: "允许",
    denied: "拒绝",
    permissions: {
      dashboard: "工作台",
      candidateUsers: "考生用户目录",
      users: "用户管理",
      resetUserPassword: "重置用户密码",
      impersonateCandidate: "代入考生",
      system: "系统设置",
      auditLogs: "审计日志",
      questions: "题库管理",
      archiveQuestions: "归档题目",
      deleteQuestions: "删除题目",
      publishQuestions: "发布题目",
      questionExperience: "题目体验治理",
      papers: "试卷管理",
      exams: "考试管理",
      execution: "运行监控",
      docker: "环境实例",
      assets: "资产中心",
      review: "阅卷复核",
    },
  },
  manualPicker: {
    pageTitle: "手工组选题工作台",
    pageSubtitle: "左侧筛题，右侧维护已选题；保存后回到试卷页继续确认。",
    missingDraftToken: "缺少 draft_token，无法进入选题工作台。",
    missingDraftTokenForSave: "缺少选题草稿标识，无法保存",
    draftSaved: "选题草稿已保存",
    selectAtLeastOneBeforeReturn: "至少选择 1 道题后再返回",
    perQuestionScore: "每题 {score} 分",
    inconsistentPerQuestionScore: "每题分值不一致",
    abortConfirmTitle: "放弃并返回？",
    abortConfirmDescription: "当前未保存的改动会丢失。",
    abortConfirmOk: "放弃返回",
    abortConfirmCancel: "继续编辑",
    abortAction: "放弃返回",
    saveDraftOnly: "仅保存草稿",
    saveAndReturn: "保存并返回",
    previewTitle: "考生视角预览",
    previewPaper: "试卷：{title}",
    previewQuestionCount: "题目：{count} 题",
    previewTotalScore: "总分：{score}",
    previewDuration: "时长：{duration}",
    unnamedPaper: "未命名试卷",
    typeSummaryLine: "{label}：共 {count} 题，{perQuestionText}，共 {totalScore} 分",
    typeSummaryEmpty: "题型分布：-",
    previewEmpty: "当前还没有已选题目，无法预览考生视图。",
    sectionTitle: "{label} 共{count}题，{perQuestionText}，共{totalScore}分",
    questionTitle: "题目{index}",
    doneTitle: "选题已保存",
    doneDescription: "已将选题结果同步到试卷创建页。",
    doneHint: "请返回上一个标签页继续操作，系统会自动提示是否应用本次选题结果。",
    doneOpenCreatePage: "回到试卷创建页",
  },
  confirmArchive: {
    title: "确认归档该试卷？",
    description: "归档后默认不在常用列表展示；不会影响已绑定考试。",
  },
  confirmDeleteDraft: {
    title: "确认彻底删除该草稿试卷？",
    description: "仅允许删除未被考试引用的草稿试卷。",
  },
  confirmPublish: {
    title: "确认发布该试卷？",
    description: "发布后试卷将可用于创建考试，请确认操作。",
  },
  detail: examAdminPapersDetail,
} as const;
